import { SearchOptionLabelElement } from 'components/Header/components/SearchBar/SearchOption/types/SearchOptionLabelElement';
import { IFormattedSearch } from 'components/Header/index';

export const searchOptionLabelElements = (option: IFormattedSearch): SearchOptionLabelElement[] => [
  { label: 'Display Unit ID', value: option.displayUnitId },
  { label: 'Broadsign Frame ID', value: option.broadsignFrameId },
  { label: 'Leader Frame ID', value: option.leader },
];
